import { useQuery } from '@tanstack/react-query';
import { getDataPointCatalogue } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const buildDataPointCatalogueQueryKey = (args: {
	dealId: string;
	programmeId: string;
	templateId: string;
	investorId: string;
}): string =>
	`field-binding-catalogue-${args.dealId}-${args.programmeId}-${args.templateId}-${args.investorId}`;

export const useDataPointCatalogueQuery = (
	templateId: string | null,
	investorId: string | null,
	enabled = true
) => {
	const { dealId, mipId } = useRequiredParams('dealId', 'mipId');

	const key = buildDataPointCatalogueQueryKey({
		dealId,
		programmeId: mipId,
		templateId: templateId ?? '',
		investorId: investorId ?? '',
	});

	return useQuery({
		queryKey: [key],
		queryFn: () => getDataPointCatalogue(dealId, mipId, templateId ?? '', investorId ?? ''),
		enabled: !!templateId && enabled,
		// The investor is part of the key, so changing the previewed recipient is a NEW query —
		// and the app's client sets `gcTime: 0`, so there is never a cache hit and `data` would
		// go undefined mid-edit. Holding the previous payload keeps the palette, the securities
		// and the scoped label lookup populated across the switch: without it every scoped chip
		// in the document flicked back to its humanised name while the request was in flight.
		placeholderData: (previous) => previous,
	});
};
